module.exports = __webpack_public_path__ + "img/megapot_white.5dd985a9.svg";